import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class FontSizesTransform extends EldmlTransform {
  apply() {
    this.selector.find("[font-size]").each(function (_: any, element: Element) {
      const font = $(element);
      const fontSize = font.attr("font-size");
      if (!isNaN(parseFloat(fontSize ?? ""))) {
        const currentStyle = font.attr("style") || "";
        font.attr("style", `${currentStyle} font-size: ${fontSize}pt;`);
      } else if (fontSize === "small" || fontSize === "large") {
        const currentStyle = font.attr("style") || "";
        font.attr("style", `${currentStyle} font-size: ${fontSize};`);
      } else if (fontSize === "normal") {
        const currentStyle = font.attr("style") || "";
        font.attr(
          "style",
          `${currentStyle} font-size: var(--eldml-base-font-size);`,
        );
      }

      font.removeAttr("font-size");
    });
  }
}
